export const numberWithCommas = (x: string | number | null | undefined): string | number => {
  if (!x) {
    return 0;
  }
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export function read_django_error(htmlText: string): { code: string | null; message: string | null } {
  const errorMessageRegex = /<h1>([^<]*)<\/h1>/s;
  const exceptionValueRegex = /<pre class="exception_value">([^<]*)<\/pre>/s;

  const errorMessageMatch = htmlText.match(errorMessageRegex);
  const errorMessage = errorMessageMatch ? errorMessageMatch[1].trim() : null;

  const exceptionValueMatch = htmlText.match(exceptionValueRegex);
  const exceptionValue = exceptionValueMatch ? exceptionValueMatch[1].trim() : null;

  return {
    code: errorMessage,
    message: exceptionValue,
  };
}
